/* eslint-disable import/prefer-default-export */
import store from '../store';

export const getLibrarySearchParam = () => {
  const { libraryPage } = store.getState();
  const { librarySearchParam } = libraryPage;
  const res = { ...librarySearchParam };
  return res;
};
